import type { QuizStatus } from './Performance';

export type SubUnit = {
    orderNum: number;
    uuid: string;
    title: string;
};

export type SubjectCode = {
    type: string;
    label: string;
    description: string;
};

export type Foil = {
    uuid: string;
    letter: string;
    isCorrectAnswer: boolean;
    answer: string;
    explanation: string;
};

export type ExamFoil = {
    letter: string;
    foilLetter: string;
};

export enum TestType {
    Study = 'study',
    Final = 'final',
    Optional = 'optional',
    Stage = 'stage',
    Practice = 'practice',
    Eoc = 'eoc',
}

export type TestSession = {
    id: number;
    userRatingId: number;
    type: TestType;
    status: QuizStatus;
    startedDateTime: Date;
};

export type SubUnitTestSession = {
    id: number;
    studyUnitUuid: string;
    subUnitUuid: string;
    testSession: SubUnitTestSession;
};

// probably just a question later on?
export type StudyQuestion = {
    uuid: string;
    canonicalUuid: string;
    orderNum: number;
    stem: string;
    foilHeader: string;
    foils: Foil[];
    isCorrect: boolean;
    isMarked: boolean;
    firstAnswer: string;
    lastAnswer: string;
    sources: string[];
    subUnit: SubUnit;
    subjectCode: SubjectCode;
    faaNumber: string;
};

export type ExamQuestion = {
    sequenceNumber: number;
    firstAnswer: string;
    lastAnswer: string;
    isCorrect: boolean;
    isMarked: boolean;
    examFoils: ExamFoil[];
    studyQuestion: StudyQuestion;
};

export type QuestionFoil = {
    answer: string,
    letter: string,
    correct: boolean,
    explanation: string,
};

export type Question = {
    number: number,
    stem: string,
    foils: QuestionFoil[],
    selected: string|null,
    marked: boolean,
    isCorrect?: boolean,
    visible: boolean,
    subUnit?: SubUnit,
};

export enum QuestionStatus {
    correct = 'correct',
    incorrect = 'incorrect',
    skipped = 'skipped',
    flagged = 'flagged',
}
